import React from 'react';
import VerticalNav from 'components/v2/navs/VerticalNav';
import { useTranslation } from 'react-i18next';
import { isProd } from 'helpers/helper_functions';
export default function SidebarNav({ activeTab = 'drayageFsc', user }) {
    const { t } = useTranslation();
    return (React.createElement("ul", { className: "flex flex-col gap-y-7" },
        React.createElement("li", null,
            React.createElement("div", { className: "text-xs font-semibold leading-6 text-gray-400" }, t('DRAYAGE')),
            React.createElement(VerticalNav, null,
                React.createElement(VerticalNav.NavItem, { url: `/users/${user.id}/settings/rates`, active: activeTab === 'drayageFsc' }, t('FSC').toUpperCase())),
            React.createElement(VerticalNav, null,
                React.createElement(VerticalNav.NavItem, { url: `/users/${user._id}/rate-card`, active: activeTab === 'drayageRateCard' }, t('DRAYAGE_RATE_CARD')))),
        !isProd() && (React.createElement("li", null,
            React.createElement("div", { className: "text-xs font-semibold leading-6 text-gray-400" }, t('SHORTHAUL')),
            React.createElement(VerticalNav, null,
                React.createElement(VerticalNav.NavItem, { url: `/users/${user.id}/settings/rates/shorthaul/fsc`, active: activeTab === 'shorthaulFsc' }, t('FSC').toUpperCase()))))));
}
